/*
 * ZOVERE — storefront behaviour (2026-10-18). Replaces zovere-futuristic.js.
 *
 * One job: fade [data-zov-reveal] elements up as they scroll into view.
 * Elements are visible by default; only those that start below the fold are
 * hidden, so nothing disappears without JavaScript, and reduced-motion users
 * see everything immediately. Dawn's own scroll animations cover its native
 * sections, so this touches ZOVERE sections only.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supported = 'IntersectionObserver' in window;
  var observer = null;

  function reveal(el) {
    el.classList.remove('is-pending');
    el.classList.add('is-visible');
  }

  function init(root) {
    if (reduced || !supported) return;

    var scope = root || document;
    var els = scope.querySelectorAll('[data-zov-reveal]:not(.is-visible):not(.is-pending)');
    if (!els.length) return;

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    var fold = window.innerHeight * 0.92;
    els.forEach(function (el) {
      // Already on screen at load: leave it alone rather than flash it out.
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('is-pending');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders a section in place: initialise just that one.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
